/* eslint-disable react/no-unescaped-entities */
import { cn } from '@/lib/utils';
import { Fragment } from 'react';
import { getImageProps } from 'next/image';
import classes from './categories.module.css';

const Categories = props => {
  const categories = {
    categories: [
      {
        name: 'Apparel',
        src: `Apparel`,
        mb: 120,
        mmb: 80,
        backgroundImage: 'media/wysiwyg/homepage/category-m1.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category1.webp',
        links: [
          {
            text: 'Shop Now',
            url: '/apparel',
          },
        ],
      },
      {
        name: 'waders',
        src: `waders`,
        mb: 120,
        mmb: 80,
        backgroundImage: 'media/wysiwyg/homepage/category-m2.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category2.webp',
        links: [
          {
            text: 'Shop Now',
            url: '/waders',
          },
        ],
      },
      {
        name: 'Hunting & Fishing Boots',
        mname: (
          <>
            Hunting &<br />
            Fishing Boots
          </>
        ),
        mb: 40,
        mmb: 80,
        src: `Hunting`,
        backgroundImage: 'media/wysiwyg/homepage/category-m3.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category3.webp',

        links: [
          {
            text: "Men's",
            url: '/mens-hunting-boots',
          },
          {
            text: "Women's",
            url: '/womens-hunting-boots',
          },
        ],
      },
      {
        name: 'Farm & Garden Boots',
        mname: (
          <>
            Farm & <br />
            Garden Boots
          </>
        ),
        mb: 40,
        mmb: 80,
        src: `Farm`,
        backgroundImage: 'media/wysiwyg/homepage/category-m4.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category4.webp',

        links: [
          {
            text: "Men's",
            url: '/mens-garden-boots',
          },
          {
            text: "Women's",
            url: '/womens-garden-boots',
          },
        ],
      },
      {
        name: 'kids Boots',
        src: `kids`,
        mb: 40,
        mmb: 80,
        backgroundImage: 'media/wysiwyg/homepage/category-m5.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category5.webp',

        links: [
          {
            text: 'Shop Now',
            url: '/kids-boots',
          },
        ],
      },
      {
        name: 'Work & Safety',
        backgroundImage: 'media/wysiwyg/homepage/category-m6.webp',
        backgroundImagePc: 'media/wysiwyg/homepage/category6.webp',

        links: [
          {
            text: "Men's",
            url: '/mens-work-boots',
          },
          {
            text: "Women's",
            url: '/womens-health-care-shoes',
          },
        ],
      },
    ],
  };
  const list01 = categories.categories.slice(0, 2);
  const list02 = categories.categories.slice(2, 5);

  return (
    <Fragment>
      <div className=' px-[12px] lg_px-0'>
        {/* <h1 className='font-oswald-bold lg_text-[44px] text-center text-[26px] uppercase'>Waterproof boots that meets all your needs.</h1>
        <h2 className='font-urw-din-medium lg_text-[1.25rem] my-6 text-center text-sm uppercase'>Shop by Categories</h2> */}

        <div className='mt-0 grid grid-cols-1 gap-[20px] md_grid-cols-2'>
          {list01.map((category, index) => (
            <Item
              category={category}
              key={index}
              size="'large'"
            />
          ))}
        </div>
        <div className='mt-[20px] grid grid-cols-1 gap-[20px] md_grid-cols-3 lg_mt-[40px]'>
          {list02.map((category, index) => (
            <Item
              category={category}
              key={index}
              size="'small'"
            />
          ))}
        </div>
      </div>
    </Fragment>
  );
};

function Item({ category, size = "'large'" }) {
  // 这里原本用 useIsMobile() 切换文案和间距。该 hook 在服务端恒为 true，服务端渲染后
  // 会与客户端实际断点不一致（hydration mismatch），所以改成纯 CSS 断点控制：
  // 两套文案都渲染、由媒体查询决定显示哪套，服务端和客户端输出因此完全一致。
  const className =
    'border-white border-1 border-solid text-white lg_border-transparent bg-transparent lg_text-primary lg_bg-white  text-sm font-oswald-bold whitespace-nowrap uppercase hover_bg-gray-100 block lg_text-[18px] font-bold px-6 py-3 lg_py-4 hover_text-orange text-center  transition';
  const btnClassName =
    'px-[20px] text-primary text-2sm font-roboto-medium font-medium block rounded-[25px] bg-white text-center sm_min-w-[140px] text-[18px] hover_bg-black hover_text-white transition-all duration-300';

  return (
    <div
      className=' translate-all group relative overflow-hidden py-[43%] duration-lg lg_py-[42%]'
    >
      <picture className="absolute inset-0 z-0">
        <source media="(max-width: 640px)" srcSet={getImageProps({ src: `/home/categories/${category.src}m.webp`, width: 750, height: 750, alt: '', sizes: "100vw", quality: 85 }).props.srcSet} sizes="100vw" />
        <source media="(min-width: 641px)" srcSet={getImageProps({ src: `/home/categories/${category.src}.webp`, width: 800, height: 800, alt: '', sizes: "(max-width: 1024px) 50vw, 33vw", quality: 85 }).props.srcSet} />
        <img 
          {...getImageProps({ src: `/home/categories/${category.src}.webp`, width: 800, height: 800, alt: '', sizes: "(max-width: 1024px) 50vw, 33vw", quality: 85 }).props}
          className="absolute left-0 top-0 h-full w-full object-cover object-center"
          loading="lazy"
        />
      </picture>
      {/* <div className='group-hover_bg-[rgba(0,0,0,.6)] lg_block absolute left-0 top-0 hidden h-full w-full bg-[rgba(0,0,0,.2)]' /> */}
      <div className='absolute left-1/2 top-1/2 z-10 h-full w-full -translate-x-1/2 -translate-y-1/2 transition-all duration-lg '>
        <div className={cn(classes.categoryInfo)}>
          <h2
            className={
              'mb-[var(--cat-mb-m)] font-teko-medium text-[30px] font-medium uppercase leading-[28px] text-white lg_mb-[var(--cat-mb-d)] lg_text-[40px] lg_leading-[40px]'
            }
            style={{
              '--cat-mb-m': `${category.mmb}px`,
              '--cat-mb-d': `${category.mb}px`,
              textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)',
            }}
          >
            <span className='lg_hidden'>{category.mname || category.name}</span>
            <span className='hidden lg_inline'>{category.name}</span>
          </h2>
          <div className='flex gap-3 lg_gap-6 lg_group-hover_flex'>
            {category.links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                className={cn(btnClassName, classes.categoryBtn)}
              >
                {link.text}
              </a>
            ))}
          </div>
          {/* {size === "'large'" &&
            category.links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                className={cn(btnClassName, classes.categoryBtn)}
              >
                {link.text}
              </a>
            ))} */}
          {/* {size === "'small'" && (
            <div className='flex gap-3 lg_gap-6 lg_group-hover_flex'>
              <a
                href={category.links.mens.url}
                className={cn(btnClassName, classes.categoryBtn)}
              >
                {category.links.mens.text}
              </a>
              <a
                href={category.links.womens.url}
                className={cn(btnClassName, classes.categoryBtn)}
              >
                {category.links.womens.text}
              </a>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default Categories;
